import React, { useEffect, useState } from 'react';
import { Footer } from '../ui';
import { ToastContainer } from 'react-toastify';
import { CartContextProvider } from '../cart';
import { NotificationContextProvider, useNotificationContext } from '../notification/contexts/NotificationContext';
import { GlobalPopup } from '../notification/components/GlobalPopup';
import { UserContextProvider } from '../user/infrastructure/UserContext';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { fetchAuthSession } from '@aws-amplify/auth';
import { NavbarComposer } from '../high-order-context/NavbarComposer';
import { FilterContextProvider } from "../features/catalog/infrastructure/FilterContext";
import { useInitialFilters } from "../features/catalog/application/useInitialFilters";
import ChatWidget from "../ui/components/ChatWidget";
import { ComercialContextProvider } from '../comercial/ComercialContext';
import ComercialBanner from '../comercial/ComercialBanner';
import { useUserContext } from '../user/infrastructure/UserContext';

const NotificationPopupWrapper = () => {
    const { pendingNotifications, changeReadStatus, acceptNotification } = useNotificationContext();
    return (
        <GlobalPopup
            notifications={pendingNotifications || []}
            actions={{
                handleMarkAsRead: (n) => changeReadStatus(n.id, true),
                handleAccept: (n) => acceptNotification(n.id)
            }}
        />
    );
};

const ComercialBannerWrapper = () => {
    const user = useUserContext();
    if (!user?.isComercial) return null;
    return <ComercialBanner />;
};

const PrivatePage = () => {
    const { user } = useAuthenticator(context => [context.user]);
    const navigate = useNavigate();
    const [shouldLoadPage, setShouldLoadPage] = useState();

    useEffect(() => {
        if (shouldLoadPage === false) {
            window.location.href = '/iniciar-sesion';
        }
    }, [shouldLoadPage, navigate]);

    useEffect(() => {
        const isAuthenticated = async () => {
            if (!!user) {
                return setShouldLoadPage(true);
            }
            const session = await fetchAuthSession();
            return setShouldLoadPage(!!session?.userSub);
        };

        isAuthenticated();
    }, [user]);

    const initialFilters = useInitialFilters();

    if (shouldLoadPage) {
        return (
            <ComercialContextProvider>
                <UserContextProvider>
                    <CartContextProvider>
                        <NotificationContextProvider>
                            <NotificationPopupWrapper />
                            <FilterContextProvider initialFilters={initialFilters}>
                                <div className="d-flex flex-column gap-3 min-vh-100">
                                    <header>
                                        <NavbarComposer />
                                    </header>

                                    <ComercialBannerWrapper />

                                    <main className="container flex-fill">
                                        <Outlet />
                                    </main>

                                    <Footer className="mt-auto" />

                                    <ToastContainer position="top-center" />
                                </div>


                                <ChatWidget />
                            </FilterContextProvider>
                        </NotificationContextProvider>
                    </CartContextProvider>
                </UserContextProvider>
            </ComercialContextProvider>
        );
    } else {
        return <></>;
    }
};

export default PrivatePage;
